(function () {
  if (window.__FULLPAGE_HERO_SLIDER_LOADED) return;
  window.__FULLPAGE_HERO_SLIDER_LOADED = true;

  var SELECTOR = '[data-fullpage-hero-slider]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function FullpageHeroSlider(root) {
    if (!root || root.__heroSliderInit) return;
    root.__heroSliderInit = true;

    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.textPanels = Array.prototype.slice.call(root.querySelectorAll('[data-hero-text-panel]'));
    this.buttons = Array.prototype.slice.call(root.querySelectorAll('[data-hero-button]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.prevBtn = root.querySelector('[data-hero-prev]');
    this.nextBtn = root.querySelector('[data-hero-next]');
    this.index = 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;
    this.autoplay = root.getAttribute('data-autoplay') === 'true';
    this.speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;

    this.initCountdown();

    if (this.slides.length <= 1) return;

    this.bind();
    this.startAutoplay();
  }

  FullpageHeroSlider.prototype.bind = function () {
    var self = this;

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.prev(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); });

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.goTo(i); });
    });

    this.root.addEventListener('focusin', function () {
      self.stopAutoplay();
      self.root.classList.add('is-paused');
    });

    this.root.addEventListener('focusout', function (e) {
      if (!self.root.contains(e.relatedTarget)) {
        self.root.classList.remove('is-paused');
        self.startAutoplay();
      }
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.prev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.next();
      }
    });

    this.root.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      self.touchStartX = e.touches[0].clientX;
      self.touchDeltaX = 0;
      self.stopAutoplay();
    }, { passive: true });

    this.root.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      self.touchDeltaX = e.touches[0].clientX - self.touchStartX;
    }, { passive: true });

    this.root.addEventListener('touchend', function () {
      if (Math.abs(self.touchDeltaX) > 48) {
        self.touchDeltaX < 0 ? self.next() : self.prev();
      }
      self.touchDeltaX = 0;
      self.startAutoplay();
    });
  };

  FullpageHeroSlider.prototype.goTo = function (index, instant) {
    var count = this.slides.length;
    if (!count) return;

    this.index = (index + count) % count;

    for (var i = 0; i < count; i++) {
      var active = i === this.index;
      this.slides[i].classList.toggle('is-active', active);
      this.slides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
    }

    for (var p = 0; p < this.textPanels.length; p++) {
      var panelActive = p === this.index;
      this.textPanels[p].classList.toggle('is-active', panelActive);
      if (panelActive) {
        this.textPanels[p].removeAttribute('hidden');
      } else {
        this.textPanels[p].setAttribute('hidden', '');
      }
    }

    for (var b = 0; b < this.buttons.length; b++) {
      var btnIndex = parseInt(this.buttons[b].getAttribute('data-index'), 10);
      var btnActive = btnIndex === this.index;
      this.buttons[b].classList.toggle('is-active', btnActive);
      this.buttons[b].setAttribute('aria-hidden', btnActive ? 'false' : 'true');
      this.buttons[b].setAttribute('tabindex', btnActive ? '0' : '-1');
    }

    for (var d = 0; d < this.dots.length; d++) {
      var dotActive = d === this.index;
      this.dots[d].classList.toggle('is-active', dotActive);
      this.dots[d].setAttribute('aria-current', dotActive ? 'true' : 'false');
    }

    if (!instant) this.restartAutoplay();
  };

  FullpageHeroSlider.prototype.next = function () { this.goTo(this.index + 1); };
  FullpageHeroSlider.prototype.prev = function () { this.goTo(this.index - 1); };

  FullpageHeroSlider.prototype.startAutoplay = function () {
    var self = this;
    if (!this.autoplay || prefersReducedMotion() || this.slides.length <= 1) return;
    this.stopAutoplay();
    this.timer = window.setInterval(function () { self.next(); }, this.speed);
  };

  FullpageHeroSlider.prototype.stopAutoplay = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  FullpageHeroSlider.prototype.restartAutoplay = function () {
    this.stopAutoplay();
    this.startAutoplay();
  };

  FullpageHeroSlider.prototype.initCountdown = function () {
    var el = this.root.querySelector('[data-hero-countdown]');
    if (!el) return;

    var hrsEl = el.querySelector('[data-countdown-hrs]');
    var minEl = el.querySelector('[data-countdown-min]');
    var secEl = el.querySelector('[data-countdown-sec]');

    function pad(n) { return String(n).length < 2 ? '0' + n : String(n); }

    // Next local midnight, in the visitor's own browser timezone.
    // Using the Date object's local getters/constructor (rather than
    // UTC) means this is automatically correct for every region ---
    // someone in Lahore gets Lahore midnight, someone in New York
    // gets New York midnight, with no geo-lookup or config needed.
    function getNextMidnight() {
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    }

    var target = getNextMidnight();

    function tick() {
      var diff = target.getTime() - Date.now();

      if (diff <= 0) {
        // Midnight passed: restart the timer for the new day.
        target = getNextMidnight();
        diff = target.getTime() - Date.now();
      }

      var totalSeconds = Math.floor(diff / 1000);
      var hrs = Math.floor(totalSeconds / 3600);
      var min = Math.floor((totalSeconds % 3600) / 60);
      var sec = totalSeconds % 60;

      if (hrsEl) hrsEl.textContent = pad(hrs);
      if (minEl) minEl.textContent = pad(min);
      if (secEl) secEl.textContent = pad(sec);
    }

    tick();
    window.setInterval(tick, 1000);
  };

  FullpageHeroSlider.prototype.destroy = function () {
    this.stopAutoplay();
    this.root.__heroSliderInit = false;
  };

  function initSlider(root) {
    if (!root) return;
    if (root.__heroSliderInstance) root.__heroSliderInstance.destroy();
    root.__heroSliderInstance = new FullpageHeroSlider(root);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var nodes = context.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = event.target.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__heroSliderInstance) {
        nodes[i].__heroSliderInstance.destroy();
        nodes[i].__heroSliderInstance = null;
      }
      nodes[i].__heroSliderInit = false;
    }
  });
})();